const isUndefined = (value: unknown): value is undefined => typeof value === 'undefined';

export default isUndefined;
